// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__BacFH","label":"styles_label__1Dfmk","caption":"styles_caption__X3KEA","description":"styles_description__1tPPT","content":"styles_content__XrwSt"};